<template>
  <div>
    <div
      :id="`popover-${item.id}`"
      class="d-flex flex-nowrap min-w-md-400px"
      style="cursor: help"
    >
      <span>{{ value }}</span>
    </div>
    <b-popover
      :target="`popover-${item.id}`"
      triggers="hover"
      placement="left"
      boundary="viewport"
      custom-class="bg-white min-w-md-800px w-md-800px max-w-1000px"
    >
      <template #title>
        <span class="small">{{ item.bp_name || item.partner_name || 'Payment Request' }}</span>
      </template>

      <b-row class="small gap-y-1">

        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <b class="text-muted">Voucher Number</b>
          <div>{{ item.voucher?.voucher_number || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <b class="text-muted">Fiscal / Calendar Year</b>
          <div>{{ item.fiscal_year?.fiscal_name || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <b class="text-muted">Transaction Type</b>
          <div>{{ item.bp_transaction_type || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <b class="text-muted">2307 Period</b>
          <div>{{ item.report_details || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <b class="text-muted">Budget Center</b>
          <div>{{ item.budget_center?.budget_name || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="9"
          class="mb-1"
        >
          <b class="text-muted">Item Description</b>
          <div>{{ item.item_center?.item?.item_name || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          class="mb-1"
        >
          <b class="text-muted">Particulars</b>
          <div>{{ item.particulars || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <b class="text-muted">Business Partner</b>
          <div>{{ item.bp_name || item.partner_name || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <b class="text-muted">TIN</b>
          <div>{{ item.bp_tin || item.tin || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <b class="text-muted">Type</b>
          <div>{{ item.bp_partner_type || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <b class="text-muted">ATC</b>
          <div>{{ item.bp_tax_description || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <b class="text-muted">Business Tax</b>
          <div>{{ item.bp_business_tax || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <b class="text-muted">Tax Status</b>
          <div>{{ item.bp_tax_status || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <b class="text-muted">Cash Adv. Account</b>
          <div>{{ item.customer_name || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <b class="text-muted">Is Cash Advance?</b>
          <div>{{ Number(item.is_cash_advance) === 1 ? 'Yes' : 'No' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="2"
          class="mb-1"
        >
          <b class="text-muted">Mode Of Payment</b>
          <div>{{ item.mop || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="2"
          class="mb-1"
        >
          <b class="text-muted">Branch</b>
          <div>{{ item.branch || '---' }}</div>
        </b-col>

        <b-col cols="12" />

        <b-col
          cols="12"
          md="2"
          class="mb-1"
        >
          <b class="text-muted">For Deposit?</b>
          <div>{{ Number(item.for_deposit) === 1 ? 'Yes' : 'No' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="2"
          class="mb-1"
        >
          <b class="text-muted">Amount</b>
          <div>{{ item.amount || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="2"
          class="mb-1"
        >
          <b class="text-muted">Invoice Amount</b>
          <div>{{ item.invoice_amount || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="2"
          class="mb-1"
        >
          <b class="text-muted">Taxable Amount</b>
          <div>{{ item.taxable_amount || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="2"
          class="mb-1"
        >
          <b class="text-muted">Withholding Tax</b>
          <div>{{ item.withholding_tax || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="2"
          class="mb-1"
        >
          <b class="text-muted">Amount Due</b>
          <div>{{ item.amount_due || '---' }}</div>
        </b-col>

        <b-col cols="12" />

        <b-col
          cols="12"
          md="4"
          class="mb-1"
        >
          <b class="text-muted">Bank</b>
          <div>{{ item.deposit_bank || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="4"
          class="mb-1"
        >
          <b class="text-muted">Account Number</b>
          <div>{{ item.deposit_account_number || '---' }}</div>
        </b-col>

        <b-col
          cols="12"
          md="4"
          class="mb-1"
        >
          <b class="text-muted">Account Name</b>
          <div>{{ item.deposit_account_name || '---' }}</div>
        </b-col>
      </b-row>
    </b-popover>
  </div>
</template>
<script>
export default {
  name: 'PaymentRequestPopover',
  props: {
    item: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  methods: {
    dateTimeShortFormatter (dateTime) {
      const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }
      return new Date(dateTime).toLocaleDateString(undefined, options)
    }
  }
}
</script>
